import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";

import { PagerService } from "../../pipe/pagination";
import * as constants from "../../app.constants";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { AbstractControl, FormControl, ValidationErrors } from "@angular/forms";
import { AdminService } from "../../service/admin.service";
import { ParsedTicketType } from "src/app/model/ticket";
declare let $: any;

const INTEGRATIONS = ["AWIN_RESERVIX", "BELBOON", "FEVER", "BILETIX"];

@Component({
  selector: "parse-tickets",
  template: require('./parse-tickets.component.html'),
  styles: [require('./parse-tickets.component.css')],
})
export class ParseTicketsComponent implements OnInit, OnDestroy {
  @ViewChild("deleteTicketModal") public deleteTicketModal: ModalComponent;
  @ViewChild("addTicketModal") public addTicketModal: ModalComponent;

  tickets = [];
  integrations = INTEGRATIONS;
  integration = INTEGRATIONS[0];
  ticket: ParsedTicketType;

  page: number;
  pageSize: number;
  pageSizes: number[];
  count: number;
  pager: any = {};
  showLoader = false;
  message = constants.messages.loading;

  urlControl: FormControl;

  constructor(
    private pagerService: PagerService,
    private adminService: AdminService
  ) {
    this.page = 1;
    this.pageSize = 10;
    this.pageSizes = [10, 20, 50, 100];
  }

  ngOnInit() {
    this.getParsedTickets();
    this.initForm();
    this.addTicketModal.onDismiss.subscribe(() => this.resetSelectedTicket());
    this.deleteTicketModal.onDismiss.subscribe(() =>
      this.resetSelectedTicket()
    );
  }

  ngOnDestroy(): void {
    this.addTicketModal.onDismiss.unsubscribe();
    this.deleteTicketModal.onDismiss.unsubscribe();
  }

  private initForm() {
    this.urlControl = new FormControl("", [this.customUrlValidator]);
  }

  private getParsedTickets(selectedPage?: number, newPageSize?: number) {
    selectedPage = selectedPage ? selectedPage : this.page;
    newPageSize = newPageSize ? newPageSize : this.pageSize;

    let pageOptions = {
      page: selectedPage,
      page_size: newPageSize,
    };

    const url = constants.URLs.parseTicketsFromUrl + "?" + $.param(pageOptions);

    this.showLoader = true;
    this.adminService
      .getCall(url, true)
      .then((res) => {
        this.showLoader = false;
        this.count = res.count;
        this.tickets = res.results;
        this.message = null;
        this.page = selectedPage;
        this.pageSize = newPageSize;
        this.pager = this.pagerService.getPager(
          this.count,
          selectedPage,
          newPageSize
        );
      })
      .catch((e) => this.showErrorMessage(e));
  }

  private addParsedTickets() {
    const data = {
      service: this.integration,
      url: this.urlControl.value,
    };

    this.showLoader = true;
    this.adminService
      .postCall(constants.URLs.parseTicketsFromUrl, data, true)
      .then(() => {
        this.showLoader = false;
        this.closeAddTicketModal();
        this.getParsedTickets();
      })
      .catch((e) => this.showErrorMessage(e));
  }

  private deletedParsedTickets() {
    this.showLoader = true;
    this.adminService
      .deleteCall(constants.URLs.parseTicketsFromUrl + this.ticket.id, true)
      .then(() => {
        this.showLoader = false;
        this.closeDeleteTicketModal();
        this.getParsedTickets();
      })
      .catch((e) => this.showErrorMessage(e));
  }

  private updateParsedTickets() {
    const data = {
      service: this.integration,
      url: this.urlControl.value,
    };

    this.showLoader = true;
    this.adminService
      .patchCall(
        constants.URLs.parseTicketsFromUrl + this.ticket.id,
        data,
        true
      )
      .then(() => {
        this.showLoader = false;
        this.closeAddTicketModal();
        this.getParsedTickets();
      })
      .catch((e) => this.showErrorMessage(e));
  }

  private showErrorMessage(error: any) {
    this.showLoader = false;

    let errorMsg;
    try {
      errorMsg = error.json().error_msg || constants.messages.serverError;
    } catch (e) {
      errorMsg = error.message ? error.message : constants.messages.serverError;
    }
    this.adminService.showErrorToast(errorMsg);
  }

  goToPage(selectedPage: number) {
    if (this.pager.currentPage === selectedPage) {
      return;
    }
    if (selectedPage < 1 || selectedPage > this.pager.totalPages) {
      return;
    }

    this.getParsedTickets(selectedPage);
  }

  onPageSizeChange(newPageSize: number): void {
    this.getParsedTickets(1, newPageSize);
  }

  openDeleteTicketModal(ticket: ParsedTicketType) {
    this.ticket = ticket;
    this.deleteTicketModal.open();
  }

  closeDeleteTicketModal() {
    this.deleteTicketModal.dismiss();
  }

  deleteTicket() {
    this.deletedParsedTickets();
  }

  openAddTicketModal() {
    this.addTicketModal.open();
  }

  closeAddTicketModal() {
    this.addTicketModal.dismiss();
  }

  addTicket() {
    if (this.urlControl.valid) {
      this.addParsedTickets();
    }
  }

  openUpdateTicketModal(ticket: ParsedTicketType) {
    const option =
      this.integrations.find((value) => value === ticket.service) ||
      this.integrations[0];

    this.ticket = ticket;
    this.integration = option;
    this.urlControl.setValue(ticket.url);

    this.addTicketModal.open();
  }

  updateTicket() {
    if (this.urlControl.valid) {
      this.updateParsedTickets();
    }
  }

  resetSelectedTicket() {
    this.ticket = undefined;
    this.urlControl.reset();
    this.integration = INTEGRATIONS[0];
  }

  onIntegrationChange(value: string) {
    this.integration = value;
  }

  customUrlValidator(control: AbstractControl): ValidationErrors | null {
    const urlRegex =
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

    const valid = urlRegex.test(control.value);
    return valid ? null : { invalidUrl: true };
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/manage/parse-tickets/parse-tickets.component.ts